// gavion.email.templates.* — templates list, editor, preview, lint, approval (owned by B5-T13).
export const templatesMessages = {
  fr: {
    title: "Modèles",
    new: "Nouveau modèle",
    edit_title: "Modifier le modèle",
    new_title: "Nouveau modèle",
    install_defaults: "Installer les modèles par défaut",
    seeded: "%{count} modèles installés",
    show_archived: "Afficher les archivés",
    default_badge: "Par défaut",
    draft_badge: "Brouillon — à approuver",
    archived_badge: "Archivé",
    empty: "Aucun modèle pour l'instant.",
    archive_named: "Archiver %{name}",
    archived: "Modèle archivé.",
    archive_title: "Archiver ce modèle ?",
    archive_body:
      "Le modèle « %{name} » ne sera plus proposé pour les nouvelles campagnes et séquences. Vous pourrez le retrouver avec « Afficher les archivés ».",
    archive_confirm: "Confirmer l'archivage",
    copy_changed: "Modifié — nouvelle approbation requise",
    // GAVION template attachments
    files: {
      title: "Pièces jointes",
      hint: "Ajoutées au courriel quand le modèle est choisi dans « Écrire un courriel », et à chaque envoi d'une séquence qui utilise un modèle de type séquence (jamais dans les campagnes). 10 Mo au total. Enregistrées tout de suite, sans nouvelle approbation.",
      add: "Joindre un fichier",
      remove: "Retirer %{name}",
      empty: "Aucune pièce jointe.",
      save_first: "Enregistrez le modèle pour lui ajouter des pièces jointes.",
      too_large:
        "Pièces jointes trop volumineuses (10 Mo au total, 10 fichiers au plus).",
      blocked: "Ce type de fichier n'est pas accepté.",
      failed: "La pièce jointe n'a pas pu être enregistrée. Réessayez.",
    },
    // GAVION rep-missed-call: the « Appel manqué » pair (R25), editable by reps, stays approved
    missed_call_note:
      "Courriel automatique « Appel manqué » (règle R25) : vos modifications restent approuvées et les envois continuent. Le nom, le type et la langue ne se changent pas.",
    rep_hint:
      "Vous pouvez modifier le courriel « Appel manqué » envoyé automatiquement après vos appels sans réponse.",
    send_test_dirty: "Enregistrez vos modifications avant d'envoyer un test.",
    columns: {
      name: "Nom",
      kind: "Type",
      language: "Langue",
      updated_at: "Modifié le",
      status: "Statut",
      actions: "Actions",
    },
    fields: {
      name: "Nom",
      kind: "Type",
      language: "Langue",
      subject: "Objet",
      preheader: "Pré-en-tête",
      body: "Corps du courriel",
    },
    fields_in: {
      subject: "l'objet",
      preheader: "le pré-en-tête",
      body: "le corps",
    },
    preview: "Aperçu",
    preview_lead: "Compagnie pour l'aperçu",
    sample_data: "Données d'exemple",
    desktop: "Ordinateur",
    mobile: "Mobile",
    preview_width: "Largeur de l'aperçu",
    preview_unavailable:
      "Aperçu indisponible : corrigez les erreurs du modèle pour le voir.",
    preview_no_footer:
      "Ce type de courriel n'a pas de pied de page LCAP (désabonnement).",
    send_test: "M'envoyer un test",
    send_test_hint: "Enregistrez le modèle pour pouvoir envoyer un test.",
    test_sent: "Courriel de test envoyé à votre adresse.",
    no_casl_footer:
      "Test envoyé sans pied de page LCAP : ce type (individuel ou transactionnel) ne doit pas servir à du marketing.",
    approve: "Approuver",
    approve_title: "Approuver ce modèle ?",
    approve_body:
      "Ce modèle a été installé par défaut et attend votre approbation. En l'approuvant, vous confirmez avoir relu le texte et qu'il peut être utilisé dans les campagnes et les séquences.",
    approve_confirm: "Je confirme l'approbation",
    approve_dirty: "Enregistrez vos modifications avant d'approuver.",
    approved: "Modèle approuvé.",
    warnings_title: "Avertissements (n'empêchent pas l'enregistrement)",
    lint: {
      subject_all_caps: "Objet entièrement en majuscules",
      too_many_links: "Plus de 3 liens (%{detail})",
      image_missing_alt: "Image sans texte alternatif (%{detail})",
      image_only: "Le message ne contient presque que des images",
      spam_word: "Mot à risque : « %{detail} »",
    },
    unknown_variables: "Variables inconnues : %{list}",
    placeholders_warning: "À compléter avant approbation",
    errors: {
      name_required: "Le nom est obligatoire.",
      subject_required: "L'objet est obligatoire.",
      body_required: "Le corps du courriel est obligatoire.",
      syntax: "Erreur de syntaxe dans %{field} : %{detail}",
      render: "Le rendu final du courriel échoue : %{detail}",
    },
    codes: {
      forbidden_tag: "balise HTML non permise.",
      forbidden_attr: "attribut HTML non permis.",
      unbalanced_markup: "balises HTML mal fermées.",
      unsafe_url_attr: "lien non sécurisé (https:// ou mailto: seulement).",
      block_in_url_attr: "condition {{#if}} interdite dans un lien.",
      unquoted_url_attr:
        'variable dans un lien sans guillemets (écrivez href="…").',
      unquoted_attr_var:
        'variable dans un attribut sans guillemets (écrivez attribut="…").',
      unfilled_placeholder: "texte « [[…]] » encore à compléter.",
      casl_footer_missing: "le pied de page LCAP est absent.",
      postal_address_missing:
        "adresse postale manquante (Paramètres → Courriels).",
      triple_stash: "les variables {{{…}}} ne sont pas permises.",
      unclosed_tag: "balise {{ non fermée.",
      bad_path: "nom de variable invalide dans une condition.",
      bad_tag: "balise {{…}} invalide.",
      stray_else: "{{else}} sans {{#if}} correspondant.",
      unbalanced_block: "bloc {{#if}} / {{/if}} mal imbriqué.",
      unclosed_block: "bloc {{#if}} non fermé.",
      unknown: "erreur inconnue.",
    },
  },
  en: {
    title: "Templates",
    new: "New template",
    edit_title: "Edit template",
    new_title: "New template",
    install_defaults: "Install default templates",
    seeded: "%{count} templates installed",
    show_archived: "Show archived",
    default_badge: "Default",
    draft_badge: "Draft — needs approval",
    archived_badge: "Archived",
    empty: "No templates yet.",
    archive_named: "Archive %{name}",
    archived: "Template archived.",
    archive_title: "Archive this template?",
    archive_body:
      "The template “%{name}” will no longer be offered for new campaigns and sequences. You can find it again with “Show archived”.",
    archive_confirm: "Confirm archiving",
    copy_changed: "Changed — new approval required",
    // GAVION template attachments
    files: {
      title: "Attachments",
      hint: "Added to the email when the template is picked in “Write an email”, and to every send of a sequence that uses a sequence-type template (never in campaigns). 10 MB in total. Saved right away, no new approval.",
      add: "Attach a file",
      remove: "Remove %{name}",
      empty: "No attachments.",
      save_first: "Save the template to add attachments to it.",
      too_large: "Attachments too large (10 MB in total, 10 files at most).",
      blocked: "This file type is not accepted.",
      failed: "The attachment could not be saved. Try again.",
    },
    // GAVION rep-missed-call: the « Missed call » pair (R25), editable by reps, stays approved
    missed_call_note:
      "Automatic « Missed call » email (rule R25): your changes stay approved and sending continues. The name, type and language cannot be changed.",
    rep_hint:
      "You can edit the « Missed call » email sent automatically after your unanswered calls.",
    send_test_dirty: "Save your changes before sending a test.",
    columns: {
      name: "Name",
      kind: "Type",
      language: "Language",
      updated_at: "Updated",
      status: "Status",
      actions: "Actions",
    },
    fields: {
      name: "Name",
      kind: "Type",
      language: "Language",
      subject: "Subject",
      preheader: "Preheader",
      body: "Email body",
    },
    fields_in: {
      subject: "the subject",
      preheader: "the preheader",
      body: "the body",
    },
    preview: "Preview",
    preview_lead: "Lead for the preview",
    sample_data: "Sample data",
    desktop: "Desktop",
    mobile: "Mobile",
    preview_width: "Preview width",
    preview_unavailable:
      "Preview unavailable: fix the template errors to see it.",
    preview_no_footer: "This email type has no CASL footer (unsubscribe).",
    send_test: "Send me a test",
    send_test_hint: "Save the template to send a test.",
    test_sent: "Test email sent to your address.",
    no_casl_footer:
      "Test sent without a CASL footer: this type (one-to-one or transactional) must not be used for marketing.",
    approve: "Approve",
    approve_title: "Approve this template?",
    approve_body:
      "This template was installed by default and awaits your approval. By approving it, you confirm you have read the copy and that it may be used in campaigns and sequences.",
    approve_confirm: "I confirm the approval",
    approve_dirty: "Save your changes before approving.",
    approved: "Template approved.",
    warnings_title: "Warnings (saving is still allowed)",
    lint: {
      subject_all_caps: "Subject is all capitals",
      too_many_links: "More than 3 links (%{detail})",
      image_missing_alt: "Image without alternative text (%{detail})",
      image_only: "The message is almost only images",
      spam_word: "Risky word: “%{detail}”",
    },
    unknown_variables: "Unknown variables: %{list}",
    placeholders_warning: "To complete before approval",
    errors: {
      name_required: "The name is required.",
      subject_required: "The subject is required.",
      body_required: "The email body is required.",
      syntax: "Syntax error in %{field}: %{detail}",
      render: "The final email render fails: %{detail}",
    },
    codes: {
      forbidden_tag: "HTML tag not allowed.",
      forbidden_attr: "HTML attribute not allowed.",
      unbalanced_markup: "HTML tags not closed properly.",
      unsafe_url_attr: "unsafe link (https:// or mailto: only).",
      block_in_url_attr: "{{#if}} conditions are not allowed in a link.",
      unquoted_url_attr: 'variable in an unquoted link (write href="…").',
      unquoted_attr_var:
        'variable in an unquoted attribute (write attribute="…").',
      unfilled_placeholder: "“[[…]]” text still needs to be completed.",
      casl_footer_missing: "the CASL footer is missing.",
      postal_address_missing: "postal address missing (Settings → Emails).",
      triple_stash: "{{{…}}} variables are not allowed.",
      unclosed_tag: "unclosed {{ tag.",
      bad_path: "invalid variable name in a condition.",
      bad_tag: "invalid {{…}} tag.",
      stray_else: "{{else}} without a matching {{#if}}.",
      unbalanced_block: "{{#if}} / {{/if}} block not nested properly.",
      unclosed_block: "unclosed {{#if}} block.",
      unknown: "unknown error.",
    },
  },
} as const;
